import { FunctionComponent } from "react";
import { cn } from "../../../utils/cn";
export interface LineLoaderProps {
  className?: string;
}

/**
 *
 */
export const LineLoader: FunctionComponent<LineLoaderProps> = ({
  className,
}) => {
  const css = cn(className, "line-loader z-10");
  return (
    <div className={css}>
      <div className="line-loader__wrapper">
        <div className="line-loader__line bg-primary-500"></div>
      </div>
    </div>
  );
};
